import { useTenantSettings } from 'react-common'

type KnowledgeModelId = string
type TutorTenantSetting = {
  enabled: boolean
  defaultKnowledgeModelId: KnowledgeModelId
}

export const useKnowledgeModelSettings = () => {
  const tenantSettings = useTenantSettings<TutorTenantSetting>('learner.tutor', true)

  return {
    defaultKnowledgeModelId: tenantSettings?.defaultKnowledgeModelId,
    enabled: tenantSettings?.enabled,
  }
}
